<template>
  <roe-error-message :field="design.effective_date_autoenroll">
    <datepicker
      v-model="design.$model.effective_date_autoenroll"
      :disabled-dates="disableDates"
    ></datepicker>
  </roe-error-message>
</template>

<script>
import RoeErrorMessage from "@/components/_shared/inputs/ErrorMessage";
import { AutoEnrollmentMixin } from "@/components/_shared/inputs/design/_mixins";
import Datepicker from "vuejs-datepicker";
export default {
  name: "RoeAutoEnrollmentEffectiveDateInput",
  components: { Datepicker, RoeErrorMessage },
  mixins: [AutoEnrollmentMixin],
  props: {
    design: Object
  },
  mounted() {
    this.design.$model.effective_date_autoenroll =
      this.design.$model.effective_date_autoenroll || new Date();
  },
  computed: {
    disableDates() {
      return {
        from: new Date()
      };
    }
  }
};
</script>
